module.exports = __webpack_public_path__ + "img/apple_icon.123a9949.svg";